import { call, put, takeLatest } from 'redux-saga/effects';
import { TDungeonEncounterSummary } from '../../../shared/types/raidTypes';
import { siteMetaActions, siteMetaActionTypes } from '../reducers/siteMetaReducer';
import { apiServiceAsync } from '../services/apiService';

function* loadDungeonEncounters() {
  try {
    yield put(siteMetaActions.updateDungeonEncounters({ isLoading: true, isLoaded: false, data: [] }));
    const encounters: TDungeonEncounterSummary[] = yield call(apiServiceAsync.getDungeonEncounters);
    yield put(siteMetaActions.updateDungeonEncounters({ data: encounters, isLoading: false, isLoaded: true }));
  } catch (error) {
    console.error('Failed to load dungeon encounters:', error);
    yield put(siteMetaActions.updateDungeonEncounters({ isLoading: false, isLoaded: true, data: [] }));
  }
}

export default [takeLatest(siteMetaActionTypes.LOAD_DUNGEON_ENCOUNTERS, loadDungeonEncounters)];
